const root = document.documentElement

export function isTouchDevice(): boolean {
  return window.matchMedia('(pointer: coarse)').matches
}

export function trackViewportHeight(): void {
  const vv = window.visualViewport
  if (!vv) return

  const sync = (): void => {
    root.style.setProperty('--app-h', `${vv.height}px`)
    if (window.scrollY !== 0) window.scrollTo(0, 0)
  }

  vv.addEventListener('resize', sync)
  vv.addEventListener('scroll', sync)
  window.addEventListener('orientationchange', () => requestAnimationFrame(sync))
  sync()
}

export function trackCanvasBox(box: HTMLElement): void {
  new ResizeObserver((entries) => {
    root.style.setProperty('--canvas-h', `${entries[0].contentRect.height}px`)
  }).observe(box)
}

export function setRootFlag(name: string, on: boolean): void {
  root.classList.toggle(name, on)
}
